// Website related settings

export const settings = {
    googleTrackingID: "UA-155124426-1",
  };
  

  
